import React, { useState, useEffect, useRef } from "react";
import { ModelWrapperWithButton } from "../../component/ModelWrapperWithButton";
import EmailChange from "./models/EmailChange";
import PasswordChange from "./models/PasswordChange";
import ChangePhone from "./models/ChangePhone";
import { FormattedMessage, useIntl } from "react-intl";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { getCompany } from "sr/utils/api/company/getCompany";
import { updateCompany } from "sr/utils/api/company/updateCompany";
import ContentLoader from "react-content-loader";
import ContentWithLoader from "sr/layout/common/ContentLoader";
import { useAuth } from "app/pages/module/auth";
import { sendOTP } from "sr/utils/api/sendOTP";
import { Input } from "sr/helpers";
import { verifyOTP } from "sr/utils/api/verifyOTP";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import NameChange from "./models/NameChange";
import { deleteUser } from "sr/utils/api/user/deleteUser";
import {
  clearEmailVerificationPending,
  isEmailVerificationPending,
  markEmailVerificationPending,
} from "sr/helpers/functions/emailVerificationOverride";

export const AccountSettings = () => {
  const intl = useIntl();
  const [showModal, setShowModal] = useState(false);
  const [companyId, setCompanyId] = useState();
  const [activeComponent, setActiveComponent] = useState<any>({});
  const [data, setData] = useState<any>({});
  const [formData, setFormData] = useState<any>({});
  const [loader, setLoader] = useState(true);
  const { logout } = useAuth();
  const [otpsend, setOtpSend] = useState<string>("");
  const [showDeleteAccountModal, setShowDeleteAccountModal] = useState(false);
  const [deleteReason, setDeleteReason] = useState("");
  const [deleteAccountLoader, setDeleteAccountLoader] = useState(false);
  const HandleModel = (data: any) => {
    setShowModal(data);
  };
  const [otp, setOTP] = useState<string>("");
  const isEmailVerified =
    data?.isEmailVerified === true &&
    !isEmailVerificationPending("company", companyId, data?.email);

  const HandleData = (data: any) => {
    setFormData(data);
  };

  useEffect(() => {
    const getdetails = getUserDetails();
    setCompanyId(getdetails.user_id);
  }, []);
  const fetchData = async () => {
    setLoader(true);
    try {
      const queryParams = new URLSearchParams();
      if (companyId) queryParams.append("id", companyId);
      const result = await getCompany(queryParams);
      if (result?.success === true) {
        setLoader(false);
        setData(result?.data);
      }
    } catch (error) {
      setLoader(false);
    }
  };
  useEffect(() => {
    if (companyId) {
      fetchData();
    }
  }, [companyId]);
  const childRef = useRef(null);

  const HandleChange = async () => {
    let isValidData: boolean;

    if (childRef.current?.validateData) {
      isValidData = await childRef.current.validateData();
    }

    if (!isValidData) return;

    try {
      setLoader(true);

      if (childRef.current?.submitForm) {
        childRef.current.submitForm();
      }

      const result = await updateCompany({
        id: companyId,
        ...formData,
      });

      if (result?.success === true) {
        const isEmailChanged =
          activeComponent?.label === "EmailChange" &&
          formData?.email &&
          formData.email !== data?.email;

        if (isEmailChanged) {
          markEmailVerificationPending("company", companyId, formData.email);
        }
        await fetchData();
        setShowModal(false);
      }
    } catch (e) {
      // optional toast
    } finally {
      setLoader(false);
    }
  };
  const AllModels = [
    {
      label: "EmailChange",
      componentName: EmailChange,
      headertitle: (
        <FormattedMessage
          id="RECRUITER.ACCOUNT.SETTINGS.CHANGE_EMAIL.POPUP.TITLE"
          defaultMessage="Change email"
        />
      ),
    },
    {
      label: "CompanyNameChange",
      componentName: PasswordChange,
      headertitle: (
        <FormattedMessage
          id="RECRUITER.ACCOUNT.SETTINGS.CHANGE_PASSWORD.POPUP.TITLE"
          defaultMessage="Change password"
        />
      ),
    },
    {
      label: "ChangePhone",
      componentName: ChangePhone,
      headertitle: (
        <FormattedMessage
          id="RECRUITER.ACCOUNT.SETTINGS.CHANGE_PHONENO.POPUP.TITLE"
          defaultMessage="Change Phone Number"
        />
      ),
    },
    {
      label: "NameChange",
      componentName: NameChange,
      headertitle: "Change Name",
    },
  ];

  const openModel = (index: any) => {
    const activeComp = AllModels.filter(function (e, i) {
      return i == index;
    });

    setActiveComponent(activeComp[0]);

    setShowModal(true);
  };
  const handleOTP = async (type, cb = () => {}) => {
    setLoader(true);
    const payload = {
      channel: type,
      username: data?.username,
    };
    try {
      const otpresult = await sendOTP(payload);
      setLoader(false);
      if (otpresult?.success === true) {
        cb();
      }
    } catch (e) {
      setLoader(false);
    }
  };

  const handleVerifyOtp = async (type) => {
    try {
      const payload = {
        username: data?.username,
        otp: otp,
        channel: type || "email",
      };
      const res = await verifyOTP(payload, { authRequired: true });
      if (res?.success === true) {
        if (type === "email") {
          clearEmailVerificationPending("company", companyId);
        }
        fetchData();
        setOtpSend("");
        setOTP("");
      }
    } catch (e) {}
  };

  const handleOptOutChange = async (optOutStatus: any) => {
    if (optOutStatus !== undefined) {
      const payload = {
        id: companyId,
        sms_opt_out: optOutStatus,
      };
      setLoader(true);
      const result = await updateCompany(payload);
      if (result?.success === true) {
        fetchData();
        setShowModal(false);
      }
      setLoader(false);
    }
  };

  const handleDeleteAccount = async () => {
    const reason = deleteReason.trim();
    if (!reason) {
      toast.error("Please enter your reason");
      return;
    }

    try {
      setDeleteAccountLoader(true);
      const result = await deleteUser({ reason });

      if (result?.success === true) {
        toast.success("Account deleted successfully");
        setShowDeleteAccountModal(false);
        logout();
      }
    } finally {
      setDeleteAccountLoader(false);
    }
  };
  return (
    <ContentWithLoader
      loading={loader}
      content={
        <ContentLoader
          speed={2}
          width={900}
          height={500}
          viewBox="0 0 900 500"
          backgroundColor="#f3f3f3"
          foregroundColor="#ecebeb"
        >
          <rect x="-590" y="17" rx="3" ry="3" width="88" height="6" />
          <rect x="-161" y="4" rx="3" ry="3" width="52" height="9" />
          <rect x="-607" y="61" rx="3" ry="3" width="410" height="9" />
          <rect x="-821" y="118" rx="3" ry="3" width="380" height="9" />
          <rect x="-647" y="90" rx="3" ry="3" width="178" height="6" />
          <circle cx="-219" cy="13" r="20" />
          <rect x="-564" y="-18" rx="3" ry="3" width="88" height="6" />
          <rect x="-266" y="202" rx="3" ry="3" width="131" height="22" />
          <rect x="-580" y="-34" rx="0" ry="0" width="4" height="40" />
          <rect x="-524" y="22" rx="0" ry="0" width="157" height="3" />
          <rect x="-460" y="73" rx="0" ry="0" width="15" height="46" />
          <rect x="-541" y="79" rx="0" ry="0" width="161" height="44" />
          <rect x="-530" y="40" rx="0" ry="0" width="165" height="55" />
          <rect x="-488" y="92" rx="0" ry="0" width="200" height="63" />
          <rect x="554" y="46" rx="0" ry="0" width="40" height="12" />
          <rect x="260" y="70" rx="0" ry="0" width="2" height="1" />
          <rect x="-715" y="125" rx="0" ry="0" width="557" height="60" />
          <rect x="-531" y="97" rx="0" ry="0" width="476" height="30" />
          <rect x="-594" y="182" rx="0" ry="0" width="373" height="128" />
          <rect x="311" y="153" rx="0" ry="0" width="0" height="21" />
          <rect x="-563" y="123" rx="0" ry="0" width="84" height="2" />
          <rect x="-637" y="124" rx="0" ry="0" width="172" height="4" />
          <rect x="-566" y="133" rx="0" ry="0" width="141" height="12" />
          <rect x="-571" y="120" rx="0" ry="0" width="60" height="5" />
          <rect x="24" y="147" rx="0" ry="0" width="2" height="12" />
          <rect x="-598" y="191" rx="0" ry="0" width="132" height="11" />
          <rect x="-558" y="139" rx="0" ry="0" width="186" height="7" />
          <rect x="-647" y="187" rx="0" ry="0" width="498" height="30" />
          <rect x="-415" y="158" rx="0" ry="0" width="72" height="8" />
          <rect x="-635" y="159" rx="0" ry="0" width="481" height="32" />
          <rect x="124" y="187" rx="0" ry="0" width="2" height="26" />
          <rect x="-238" y="170" rx="0" ry="0" width="67" height="23" />
          <rect x="23" y="11" rx="0" ry="0" width="900" height="61" />
          <rect x="25" y="88" rx="0" ry="0" width="900" height="61" />
          <rect x="27" y="166" rx="0" ry="0" width="900" height="61" />
        </ContentLoader>
      }
    >
      <div className="flex justify-between items-center mb-3 pb-3 border-b border-neutral-200">
        <div>
          <h2>
            <FormattedMessage
              id="ACCOUNT.SETTINGS.FULLNAME"
              defaultMessage="Full Name"
            />
          </h2>

          <div>{`${data?.first_name || ""} ${data?.last_name || ""}`}</div>
        </div>

        <div
          onClick={() => openModel(3)}
          className="text-[#0078ae] font-bold hover:text-[#0078ae] hover:border-2 hover:border-[#C7D2F6] hover:bg-[#EEF1FE] py-2 rounded-lg text-base px-3 cursor-pointer border border-neutral-200"
        >
          Edit Name
        </div>
      </div>
      <div className="flex justify-between items-center mb-3 pb-3 border-b border-neutral-200">
        <div>
          <h2 className="">
            <FormattedMessage
              id="RECRUITER.ACCOUNT.SETTINGS.EMAIL.TITLE"
              defaultMessage="Email"
            />{" "}
          </h2>
          <div>{data?.email}</div>
          {otpsend !== "Email" && isEmailVerified && (
            <div className="flex items-center text-green-600 text-sm mt-1">
              <FontAwesomeIcon icon={faCheckCircle} className="mr-1" />
              Verified
            </div>
          )}
        </div>
        <div className="flex space-x-5">
          {otpsend !== "Email" && !isEmailVerified && (
            <div
              onClick={() => {
                handleOTP("email", () => {
                  setOtpSend("Email");
                });
              }}
              className="text-[#0078ae] font-bold hover:text-[#0078ae] hover:border-2 hover:border-[#C7D2F6] hover:bg-[#EEF1FE] py-2 rounded-lg  text-base px-3 cursor-pointer border border-neutral-200"
            >
              <FormattedMessage
                id="RECRUITER.ACCOUNT.SETTINGS.VERIFY_EMAIL.BUTTON"
                defaultMessage="Verify email"
              />
            </div>
          )}
          {otpsend === "Email" && (
            <div className="flex space-x-3">
              <Input
                onChange={(e) => setOTP(e.target.value)}
                value={otp}
                InputDivClass="mt-0"
                inputClass="border border-zinc-800 rounded-lg h-11"
              ></Input>
              <div
                onClick={() => {
                  handleVerifyOtp("email");
                }}
                className="text-[#0078ae] font-bold hover:text-[#0078ae] hover:border-2 hover:border-[#C7D2F6] hover:bg-[#EEF1FE] py-2 rounded-lg  text-base px-3 cursor-pointer border border-neutral-200"
              >
                Submit
              </div>
            </div>
          )}
          <div
            onClick={() => openModel(0)}
            className="text-[#0078ae] font-bold hover:text-[#0078ae] hover:border-2 hover:border-[#C7D2F6] hover:bg-[#EEF1FE] py-2 rounded-lg  text-base px-3 cursor-pointer border border-neutral-200"
          >
            <FormattedMessage
              id="RECRUITER.ACCOUNT.SETTINGS.CHANGE_EMAIL.BUTTON"
              defaultMessage="Change email"
            />
          </div>
        </div>
      </div>

      <div className="flex justify-between items-center mb-3 pb-3 border-b border-neutral-200">
        <div>
          <h2 className="">
            {" "}
            <FormattedMessage
              id="RECRUITER.ACCOUNT.SETTINGS.PASSWORD.TITLE"
              defaultMessage="Password"
            />
          </h2>
          <div>{data?.password}</div>
        </div>
        <div
          onClick={() => openModel(1)}
          className="text-[#0078ae] font-bold hover:text-[#0078ae] hover:border-2 hover:border-[#C7D2F6] hover:bg-[#EEF1FE] py-2 rounded-lg  text-base px-3 cursor-pointer border border-neutral-200"
        >
          <FormattedMessage
            id="RECRUITER.ACCOUNT.SETTINGS.CHANGE_PASSWORD.BUTTON"
            defaultMessage="Change password"
          />{" "}
        </div>
      </div>
      <div className="flex justify-between items-center mb-3 pb-3 border-b border-neutral-200">
        <div>
          <h2 className="">
            {" "}
            <FormattedMessage
              id="RECRUITER.ACCOUNT.SETTINGS.PHONENO.TITLE"
              defaultMessage="Phone number"
            />
          </h2>
          <div>{data?.mobile_number}</div>
          {otpsend !== "PhoneNo" && data?.isPhoneVerified === true && (
            <div className="flex items-center text-green-600 text-sm mt-1">
              <FontAwesomeIcon icon={faCheckCircle} className="mr-1" />
              Verified
            </div>
          )}
        </div>
        <div className="flex space-x-5">
          {otpsend !== "PhoneNo" && data?.isPhoneVerified !== true && (
            <div
              aria-label={
                data?.sms_opt_out == true ? "Please first Opt-In the sms " : ""
              }
              onClick={() => {
                if (
                  data?.sms_opt_out === undefined ||
                  data?.sms_opt_out === false
                ) {
                  handleOTP("sms", () => {
                    setOtpSend("PhoneNo");
                  });
                } else {
                  toast.error(
                    intl.formatMessage({
                      id: "API.ERROR.NEED.TO.DISABLE.SMSOPTOUT",
                      defaultMessage:
                        "Please Opt-In the sms to receive the otp",
                    }),
                  );
                }
              }}
              className={`text-[#0078ae] font-bold hover:text-[#0078ae] hover:border-2 hover:border-[#C7D2F6]  ${
                data?.sms_opt_out == true ? "bg-[#EEE]" : "hover:bg-[#EEF1FE]"
              } py-2 rounded-lg  text-base px-3 cursor-pointer border border-neutral-200 group relative`}
            >
              <FormattedMessage
                id="RECRUITER.ACCOUNT.SETTINGS.VERIFY_PHONENO.BUTTON"
                defaultMessage="Verify Phone Number"
              />
              {data?.sms_opt_out == true && (
                <span className="absolute z-10 top-12 right-0 scale-0 rounded bg-gray-800 p-2 text-xs text-white group-hover:scale-100">
                  {intl.formatMessage({
                    id: "API.ERROR.NEED.TO.DISABLE.SMSOPTOUT",
                    defaultMessage: "Please Opt-In the sms to receive the otp",
                  })}
                </span>
              )}
            </div>
          )}
          {otpsend === "PhoneNo" && (
            <div className="flex space-x-3">
              <Input
                onChange={(e) => setOTP(e.target.value)}
                value={otp}
                InputDivClass="mt-0"
                inputClass="border border-zinc-800 rounded-lg h-11"
              ></Input>
              <div
                onClick={() => {
                  handleVerifyOtp("sms");
                }}
                className="text-[#0078ae] font-bold hover:text-[#0078ae] hover:border-2 hover:border-[#C7D2F6] hover:bg-[#EEF1FE] py-2 rounded-lg  text-base px-3 cursor-pointer border border-neutral-200"
              >
                Submit
              </div>
            </div>
          )}
          <div
            onClick={() => openModel(2)}
            className="text-[#0078ae] font-bold hover:text-[#0078ae] hover:border-2 hover:border-[#C7D2F6] hover:bg-[#EEF1FE] py-2 rounded-lg  text-base px-3 cursor-pointer border border-neutral-200"
          >
            <FormattedMessage
              id="RECRUITER.ACCOUNT.SETTINGS.CHANGE_PHONENO.BUTTON"
              defaultMessage="Change Phone Number"
            />
          </div>
        </div>
      </div>
      <div className="flex justify-between items-center mb-3 pb-3 border-b border-neutral-200">
        {/* Left side */}
        <div>
          <h2 className="flex items-center gap-2">
            {/* Label */}
            <span className="whitespace-nowrap">
              <FormattedMessage
                id="SMSOPTOUT.LABEL"
                defaultMessage="SMS Opt out"
              />
            </span>

            {/* Info icon */}
            <div className="relative group flex-shrink-0">
              <span className="w-5 h-5 flex items-center justify-center rounded-full bg-gray-400 text-white text-xs cursor-pointer hover:bg-gray-500 transition">
                ?
              </span>

              {/* Tooltip */}
              <div className="absolute left-0 top-full pt-2 w-72 hidden group-hover:block z-50">
                <div className="bg-gray-900 text-white text-xs rounded-lg p-3 shadow-lg leading-relaxed">
                  By opting in, you agree to receive 1 or more text messages per
                  month related to job applicants, work order updates,
                  supervisor updates, promotions, and more.
                  <br />
                  <br />
                  You can update this in your account settings at any time.
                  Message and data rates may apply. Reply STOP to unsubscribe or
                  HELP for help.
                  <br />
                  <br />
                  <a
                    href="https://janijobs.com/privacy-policy/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline"
                  >
                    Privacy Policy
                  </a>{" "}
                  and{" "}
                  <a
                    href="https://support.janijobs.com/hc/en-us/articles/42346401405723-JaniJobs-Global-Terms-and-Conditions"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline"
                  >
                    Terms & Conditions
                  </a>{" "}
                  apply .
                </div>
              </div>
            </div>
          </h2>

          <div>
            {data?.sms_opt_out == true ? (
              <FormattedMessage id="SMSOPTOUT.YES" defaultMessage="Yes" />
            ) : (
              <FormattedMessage id="SMSOPTOUT.NO" defaultMessage="No" />
            )}
          </div>
        </div>

        {/* Right side (unchanged) */}
        <div className="flex items-center gap-3">
          {data?.sms_opt_out === true ? (
            <div
              className="text-[#0078ae] font-bold hover:text-[#0078ae] hover:border-2 hover:border-[#C7D2F6] hover:bg-[#EEF1FE] py-2 rounded-lg text-base px-3 cursor-pointer border border-neutral-200"
              onClick={() => handleOptOutChange(false)}
            >
              <FormattedMessage id="BTN.TEXT.OPTIN" defaultMessage="Opt-In" />
            </div>
          ) : (
            <div
              className="text-[#0078ae] font-bold hover:text-[#0078ae] hover:border-2 hover:border-[#C7D2F6] hover:bg-[#EEF1FE] py-2 rounded-lg text-base px-3 cursor-pointer border border-neutral-200"
              onClick={() => handleOptOutChange(true)}
            >
              <FormattedMessage id="BTN.TEXT.OPTOUT" defaultMessage="Opt-Out" />
            </div>
          )}
        </div>
      </div>
      <div className="flex justify-between items-center mb-3 pb-3 border-b border-neutral-200">
        <div>
          <h2 className="">Delete account</h2>
          <div>This will permanently delete your account.</div>
        </div>
        <div
          onClick={() => setShowDeleteAccountModal(true)}
          className="text-red-500 font-bold hover:text-red-600 hover:border-2 hover:border-red-200 hover:bg-red-50 py-2 rounded-lg text-base px-3 cursor-pointer border border-neutral-200"
        >
          Delete account
        </div>
      </div>
      <div className="flex justify-between items-center mb-3 pb-3 border-b border-neutral-200">
        <div>
          <h2 className="">{data?.email}</h2>
        </div>
        <div
          onClick={logout}
          className="text-[#0078ae] font-bold hover:text-[#0078ae] hover:border-2 hover:border-[#C7D2F6] hover:bg-[#EEF1FE] py-2 rounded-lg  text-base px-3 cursor-pointer border border-neutral-200"
        >
          <FormattedMessage
            id="RECRUITER.ACCOUNT.SETTINGS.SIGN_OUT.BUTTON"
            defaultMessage="Sign Out"
          />
        </div>
      </div>
      <ModelWrapperWithButton
        Save={HandleChange}
        showModal={showModal}
        onCheckModel={HandleModel}
        headertitle={activeComponent.headertitle}
        loader={loader}
      >
        {
          <activeComponent.componentName
            HandleData={HandleData}
            ref={childRef}
            HandleModel={HandleModel}
            data={data}
          />
        }
      </ModelWrapperWithButton>
      <ModelWrapperWithButton
        Save={handleDeleteAccount}
        showModal={showDeleteAccountModal}
        onCheckModel={setShowDeleteAccountModal}
        headertitle="Delete account"
        loader={deleteAccountLoader}
        savetext="Delete account"
      >
        <div>
          <p className="mb-4">
            Are you sure you want to delete your account? This action cannot be
            undone.
          </p>
          <label className="block font-bold mb-2">Reason</label>
          <textarea
            value={deleteReason}
            onChange={(e) => setDeleteReason(e.target.value)}
            placeholder="Enter your reason"
            className="w-full min-h-[120px] border border-neutral-300 rounded-lg p-3"
          />
        </div>
      </ModelWrapperWithButton>
    </ContentWithLoader>
  );
};
